var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
import { Rectangle } from "./Rectangle.js";
import { UIElement } from "./UIElement.js";
import { scaleFont } from "./utils.js";
import "nanoid";
import "lodash";
import "./UIService.js";
import "../global-33d5eebf.js";
import "../inputs/InputManager.js";
import "../utils/playSound.js";
import "../loader/AssetLoader.js";
import "../loader/ImageLoader.js";
import "pixi.js";
import "../loader/SpriteLoader.js";
import "../loader/PixiSpriteLoader.js";
import "../loader/MapLoader.js";
import "../utils/colors.js";
import "../utils/sharedFetch.js";
import "../vendor/noise/index.js";
import "url";
import "@dimforge/rapier2d-compat";
import "../persist/persist.js";
import "../loader/PixiSpineLoader.js";
import "pixi-spine";
import "../loader/SoundLoader.js";
import "../_commonjsHelpers-7a77ea84.js";
import "../console/flags.js";
import "../console/editor.js";
import "../components/ComponentRegistry.js";
import "../decorators/type.js";
import "ajv";
import "../utils/clone.js";
import "bitecs";
import "../utils/typehelpers.js";
import "../enums-86f58524.js";
import "../components/types.js";
import "../utils/byteArray.js";
import "../console/floatingwindow.js";
import "../Description-c36d0b9a.js";
import "../Attach-abbbd93e.js";
import "../utils/vector.js";
import "../utils/windowSessionStorage.js";
const defaultStyle = {
  color: "white",
  backgroundColor: "transparent",
  padding: "0 1%",
  margin: "0",
  position: "absolute",
  fontFamily: "YageFont"
};
class TextInput extends UIElement {
  constructor(bounds, config) {
    if (Array.isArray(bounds)) {
      bounds = new Rectangle(bounds[0], bounds[1], 0, 0);
    }
    super(bounds, config, defaultStyle);
    __publicField(this, "focusTime", 0);
    __publicField(this, "_element");
    __publicField(this, "listenKeyPress", (e) => {
      var _a, _b, _c, _d, _e;
      e.preventDefault();
      e.stopPropagation();
      if (e.key === "Backspace") {
        this._config.value = ((_a = this._config.value) == null ? void 0 : _a.substring(0, this._config.value.length - 1)) || "";
      } else if (e.key.length === 1) {
        this._config.value = (this._config.value || "") + e.key;
      } else if (e.key === "Enter") {
        (_c = (_b = this._config).onSubmit) == null ? void 0 : _c.call(_b, this._config.value || "");
        return;
      }
      (_e = (_d = this._config).onChange) == null ? void 0 : _e.call(_d, this._config.value || "");
    });
  }
  onClickInternal(playerIndex) {
    if (this._config.onClick) {
      return this._config.onClick(playerIndex);
    }
    this.focusTime = +/* @__PURE__ */ new Date();
    document.addEventListener("keydown", this.listenKeyPress);
  }
  onMouseDownInternal(playerIndex) {
    if (this._config.onMouseDown) {
      return this._config.onMouseDown(playerIndex);
    }
  }
  onMouseUpInternal(playerIndex) {
    if (this._config.onMouseUp) {
      return this._config.onMouseUp(playerIndex);
    }
  }
  onBlurInternal(playerIndex) {
    this.focusTime = -1;
    document.removeEventListener("keydown", this.listenKeyPress);
    if (this._config.onBlur) {
      this._config.onBlur(playerIndex);
    }
  }
  onFocusInternal(playerIndex) {
    if (this._config.onFocus) {
      this._config.onFocus(playerIndex);
    }
  }
  onMouseEnterInternal(playerIndex) {
    if (this._config.onMouseEnter) {
      this._config.onMouseEnter(playerIndex);
    }
  }
  onMouseLeaveInternal(playerIndex) {
    if (this._config.onMouseLeave) {
      this._config.onMouseLeave(playerIndex);
    }
  }
  onDestroy(noUpdate) {
    super.onDestroy(noUpdate);
    document.removeEventListener("keydown", this.listenKeyPress);
  }
  createElement() {
    const element = document.createElement("input");
    element.id = this.id;
    if (this._config.focusable) {
      element.classList.add("focusable");
    }
    if (this._config.captureFocus !== void 0 && this._config.captureFocus > -1) {
      element.classList.add("captureFocus" + this._config.captureFocus);
      this.uiService.clearFocusedElementByPlayerIndex(this._config.captureFocus);
    }
    if (this._config.autoFocus) {
      element.classList.add("autoFocus");
    }
    return element;
  }
  _update() {
    super._update();
    if (!this.isVisible()) {
      return;
    }
    const textInputElement = this.element;
    if (!textInputElement) {
      return;
    }
    textInputElement.type = "text";
    textInputElement.placeholder = this._config.label;
    textInputElement.style.backgroundColor = this._config.style.backgroundColor ?? "transparent";
    textInputElement.style.fontFamily = this._config.font ?? this._config.style.fontFamily ?? "YageFont";
    textInputElement.style.color = "white";
    textInputElement.style.border = `1px solid ${this._config.style.borderColor ?? "white"}`;
    textInputElement.value = this._config.value || "";
    const scales = this.getScales();
    textInputElement.style.fontSize = `${scaleFont(this.config.fontSize || 12, scales[0] * scales[1] * scales[2])}px`;
    textInputElement.onkeyup = (e) => {
      var _a, _b;
      this._config.value = textInputElement.value;
      (_b = (_a = this._config).onChange) == null ? void 0 : _b.call(_a, this._config.value);
    };
    textInputElement.onkeydown = (e) => {
      var _a, _b;
      if (e.key === "Enter") {
        (_b = (_a = this._config).onSubmit) == null ? void 0 : _b.call(_a, textInputElement.value);
      }
    };
  }
}
export {
  TextInput
};
//# sourceMappingURL=TextInput.js.map
